import type { ShiptimeMegaShipmentProcessCreate } from '@shipium-corp/shipium-ts-types';
import type { ShiptimeService } from './index';
import * as fixtures from './fixtures';
import delay from '../mockServiceDelay';
import type { DeliveryEstimateRequest } from './types';

export const mockShiptimeService: ShiptimeService = {
  bulkLabelVoid: async () => {
    await delay();
    return Promise.resolve([]);
  },

  getShipmentIdForExactMatch: async (shipiumId: string) => {
    await delay();
    return Promise.resolve(undefined);
  },
  getShipmentByShipmentId: async (shipmentId: string) => {
    await delay();
    return Promise.resolve({ ...fixtures.mockShipmentResponse, shipiumShipmentId: shipmentId }) as any;
  },
  getShipmentLabel: async (url: string) => {
    await delay();
    return '';
  },
  createDeliveryEstimate: async (deliveryEstimateRequest: DeliveryEstimateRequest) => {
    await delay();
    return {
      desiredDeliveryDate: '2019-10-29T00:00:00.000000Z',
      fcDropByDate: '2019-10-29T00:00:00.000000Z',
      customerCountryCode: 'US',
      customerPostalCode: '98101',
      deliveryEstimateDate: '2019-10-31T00:00:00.000000Z',
      deliveryEstimateId: '0b3d140a-525b-43a7-896c-cdc381580d61',
      options: {
        backFillOptions: {
          simulated: true,
          synthetic: true,
        },
        shippingOptions: {
          fromCountryCode: 'US',
          fromPostalCode: '98101',
          shipOption: 'Standard',
        },
      },
      productId: 'RN03947--Z43121',
    };
  },
  createSubscriptionTiming: async (deliveryEstimateRequest: DeliveryEstimateRequest) => {
    await delay();
    return {
      customerCountryCode: 'US',
      customerPostalCode: '98101',
      deliveryEstimateDate: '2019-10-31T00:00:00.000000Z',
      subscriptionTimingRequestId: '0b3d140a-525b-43a7-896c-cdc381580d61',
      options: {
        backFillOptions: {
          simulated: true,
          synthetic: true,
        },
        shippingOptions: {
          fromCountryCode: 'US',
          fromPostalCode: '98101',
          shipOption: 'Standard',
        },
      },
      productId: 'RN03947--Z43121',
      subscriptionTimingRequestExpiration: '2019-10-31T00:00:00.000000Z',
      shipByDate: '2019-10-31T00:00:00.000000Z',
      fcDropByDate: '2019-10-31T00:00:00.000000Z',
    };
  },
  getDeliveryEstimate: async (deid: string) => {
    await delay();
    return {
      customerCountryCode: 'US',
      customerPostalCode: '98101',
      deliveryEstimateDate: '2019-10-31T00:00:00.000000Z',
      deliveryEstimateId: '0b3d140a-525b-43a7-896c-cdc381580d61',
      options: {
        backFillOptions: {
          simulated: true,
          synthetic: true,
        },
        shippingOptions: {
          fromCountryCode: 'US',
          fromPostalCode: '98101',
          shipOption: 'Standard',
        },
      },
      productId: 'RN03947--Z43121',
    };
  },
  getSubscriptionTiming: async (shipmentTimingId: string) => {
    await delay();
    return {
      customerCountryCode: 'US',
      customerPostalCode: '98101',
      deliveryEstimateDate: '2019-10-31T00:00:00.000000Z',
      subscriptionTimingRequestId: '0b3d140a-525b-43a7-896c-cdc381580d61',
      options: {
        backFillOptions: {
          simulated: true,
          synthetic: true,
        },
        shippingOptions: {
          fromCountryCode: 'US',
          fromPostalCode: '98101',
          shipOption: 'Standard',
        },
      },
      productId: 'RN03947--Z43121',
      subscriptionTimingRequestExpiration: '2019-10-31T00:00:00.000000Z',
      shipByDate: '2019-10-31T00:00:00.000000Z',
      fcDropByDate: '2019-10-31T00:00:00.000000Z',
    };
  },
  createLabel: async (createLabelPayload: ShiptimeMegaShipmentProcessCreate) => {
    await delay();
    return Promise.resolve(fixtures.mockShipmentResponse.carrierLabel) as any;
  },
  getShipmentCarrierSelectionById: async (shipiumShipmentId: string, carrierSelectionId: string) => {
    await delay();
    return Promise.resolve(fixtures.mockShipmentResponse.carrierSelection as any);
  },
  getLabelByLabelId: async (labelId: string) => {
    await delay();
    return Promise.resolve({} as any);
  },
  fetchLtlCostById: async (LtlCostId: string) => {
    await delay();
    return Promise.resolve({ ...fixtures.mockLtlCostResponse });
  },
  cancelShipment: async () => ({}) as any,
  fetchLabelZPL: async (shipmentID) => {
    await delay(1000);
    return `^XA
    ^LH55,30
    ^FO20,10^CFD,27,13^FDCompany Name^FS
    ^FO20,60^AD^FD<DESCRIPTION >^FS
    ^FO40,160^BY2,2.0^BCN,100,Y,N,N,N^FD<PART,-1>^FS
    ^XZ`;
  },
};
